module.exports = __webpack_public_path__ + "static/media/animate-booking.95162881.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/Tour/assets/animate-booking.gif
// module id = 3726
// module chunks = 0